module.exports = __webpack_public_path__ + "af49d3cdcecfdd24cdb5f9f3e2495d57.svg";